const refreshGrid = (history, gridName) => {
  if (!history) {
    return;
  }
  history.push({
    pathname: `/campaign/vnext/hotelcenter/overview/${gridName.toLowerCase()}`,
    search: history.location.search,
  });
};

const overviewGridPickeritems = ({ i18n, history, gridName, permissions }) => [{
  text: i18n.getString(_TL_('Hotel')),
  classes: gridName === 'HotelIdGrid' ? 'selected' : '',
  onClick: () => {
    refreshGrid(history, 'HotelIdGrid');
  },
},
{
  text: i18n.getString(_TL_('Hotel group')),
  classes: gridName === 'HotelGroupGrid' ? 'selected' : '',
  onClick: () => {
    refreshGrid(history, 'HotelGroupGrid');
  },
},
{
  text: i18n.getString(_TL_('Subaccount')),
  classes: gridName === 'HotelSubAccountGrid' ? 'selected' : '',
  disabled: permissions && permissions.dynamic.HotelCenterDeprecation,
  onClick: () => {
    refreshGrid(history, 'HotelSubAccountGrid');
  },
},
{
  text: i18n.getString(_TL_('Advanced booking window')),
  classes: gridName === 'AdvancedBookingGrid' ? 'selected' : '',
  onClick: () => {
    refreshGrid(history, 'AdvancedBookingGrid');
  },
},
{
  text: i18n.getString(_TL_('Check in day')),
  classes: gridName === 'CheckinDayGrid' ? 'selected' : '',
  onClick: () => {
    refreshGrid(history, 'CheckinDayGrid');
  },
},
{
  text: i18n.getString(_TL_('Date')),
  classes: gridName === 'HotelDateGrid' ? 'selected' : '',
  onClick: () => {
    refreshGrid(history, 'HotelDateGrid');
  },
},
{
  text: i18n.getString(_TL_('Date type')),
  classes: gridName === 'DateTypeGrid' ? 'selected' : '',
  onClick: () => {
    refreshGrid(history, 'DateTypeGrid');
  },
},
{
  text: i18n.getString(_TL_('Device type')),
  classes: gridName === 'HotelDeviceTypeGrid' ? 'selected' : '',
  onClick: () => {
    refreshGrid(history, 'HotelDeviceTypeGrid');
  },
},
{
  text: i18n.getString(_TL_('Hotel country/region')),
  classes: gridName === 'HotelCountryGrid' ? 'selected' : '',
  onClick: () => {
    refreshGrid(history, 'HotelCountryGrid');
  },
},
{
  text: i18n.getString(_TL_('Length of stay')),
  classes: gridName === 'HotelLengthOfStayGrid' ? 'selected' : '',
  onClick: () => {
    refreshGrid(history, 'HotelLengthOfStayGrid');
  },
},
{
  text: i18n.getString(_TL_('Site type')),
  classes: gridName === 'SiteTypeGrid' ? 'selected' : '',
  onClick: () => {
    refreshGrid(history, 'SiteTypeGrid');
  },
},
{
  text: i18n.getString(_TL_('Slot type')),
  classes: gridName === 'HotelSlotTypeGrid' ? 'selected' : '',
  onClick: () => {
    refreshGrid(history, 'HotelSlotTypeGrid');
  },
},
{
  text: i18n.getString(_TL_('User country/region')),
  classes: gridName === 'HotelLengthOfStayGrid' ? 'selected' : '',
  onClick: () => {
    refreshGrid(history, 'HotelUserCountryGrid');
  },
},
];

export const overviewGridPickerConfig = ({ i18n, gridName, history, permissions }) => {
  const gridNameMap = {
    HotelIdGrid: i18n.getString(_TL_('View by Hotel')),
    HotelGroupGrid: i18n.getString(_TL_('View by Hotel group')),
    HotelSubAccountGrid: i18n.getString(_TL_('View by Subaccount')),
    AdvancedBookingGrid: i18n.getString(_TL_('View by Advanced booking window')),
    CheckinDayGrid: i18n.getString(_TL_('View by Check in day')),
    HotelDateGrid: i18n.getString(_TL_('View by Date')),
    DateTypeGrid: i18n.getString(_TL_('View by Date type')),
    HotelDeviceTypeGrid: i18n.getString(_TL_('View by Device type')),
    HotelCountryGrid: i18n.getString(_TL_('View by Hotel country/region')),
    HotelLengthOfStayGrid: i18n.getString(_TL_('View by Length of stay')),
    SiteTypeGrid: i18n.getString(_TL_('View by Site type')),
    HotelSlotTypeGrid: i18n.getString(_TL_('View by Slot type')),
    HotelUserCountryGrid: i18n.getString(_TL_('View by User country/region')),
  };

  return ({
    id: 'grid-picker',
    type: 'dropdown',
    text: (gridNameMap[gridName] || i18n.getString(_TL_('View by Subaccount'))),
    menu: {
      items: overviewGridPickeritems({ i18n, history, gridName, permissions }),
    },
  });
};
